(function () {
  'use strict';
  angular.module('vcuser.vcuser')
    .component('usereditor', {
      restrict: 'E',
      bindings: {
        user: '<?',
        userid: '<?',
        roles: '<?'
      },
      template: `
        <userform user="vm.user" parentsave="vm.childsave(user)" oncancel="vm.oncancel()" roles="vm.roles"></userform>
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> User erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen User wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> User konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'User', 'Rlog', '$timeout',
        function ($log, User, Rlog, $timeout) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;

          vm.$onInit = function () {
            if (angular.isUndefined(vm.roles) || !angular.isArray(vm.roles) || vm.roles.length === 0) {
              vm.roles = [{role: 'admin', label: 'Administrator'}, {role: 'user', label: 'Anwender'}];
            }
            if ((angular.isUndefined(vm.user) || !vm.user.hasOwnProperty('_id'))
              && angular.isDefined(vm.userid)) {
              User.$find(vm.userid).$then(function (user) {
                console.log("user found: ");
                console.log(user);
                vm.user = user;
              }, function (err) {
                $log.error('user not found, id: ', vm.userid);
                Rlog.error('user', 'usereditor', 'user not found', {_id: vm.userid});
              });
            }
          };

          function childsave(user) {
            // vm.user = angular.copy(user);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in user) {
              if (user.hasOwnProperty(key)) {
                vm.user[key] = user[key];
              }
            }
            vm.save();
          }

          function save() {
            if (vm.user.$hasPendingActions()) {
              vm.user.$cancel();
              vm.user.$save().$then(function () {
                vm.saved = true;
                reset('saved');
              }, function (err) {
                vm.saved = false;
                reset('saved');
                $log.error('saving of user failed: ', err);
                Rlog.error('vcutils.user', 'usereditor', 'Saving of user failed: ', {userid: vm.user._id});
              });
            }
            else {
              vm.user.$save().$then(function () {
                vm.saved = true;
                reset('saved');
              }, function (err) {
                vm.saved = false;
                reset('saved');
                $log.error('saving of user failed: ', err);
                Rlog.error('vcutils.user', 'usereditor', 'Saving of user failed: ', {userid: vm.user._id});
              });
            }
          }

          function oncancel() {
            vm.canceled = true;
            reset('canceled');
          }

          function reset(rvar) {
            $timeout(function () {
              delete vm[rvar]
            }, 3500);
          }


        }] // controller
    }); // component

// klammerfriedhof
}());